<template>
  <div class="prenumerate">
    <div class="row end-md">
      <div
        class="col-xs-12 col-md-6"
      >
        <add-to-cart
          :product="product"
          :text="buttonText"
          :class="[disabled ? 'disabled' : '']"
          class="add-to-cart mt10 w-100 fs-medium-small"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddToCart from 'theme/components/core/AddToCart.vue'
import ProductPrice from 'theme/mixins/productPrice.ts'
import { mapGetters } from 'vuex'
import { getBundleOptionsValues, getSelectedBundleOptions } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'

export default {
  components: {
    AddToCart
  },
  mixins: [ProductPrice],
  props: {
    product: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonText () {
      return this.disabled
        ? 'Zamów za xx,xx zł'
        : 'Zamów za ' + this.$options.filters.price(this.price.default)
    }
  }
}
</script>

<style lang="scss" scoped>
.prenumerate {
  .bundleOption {
    transition: all 0.2s ease;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
      filter: grayscale(1);
    }
  }
}
.add-to-cart {
  transition: all 0.2s ease;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(1);
  }
}
</style>
